import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import {
  fetchAttachmentsAndAppendToModule,
  fetchDetailAndAppendToModule,
  fetchNotesAndAppendToModule,
} from '../../redux/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TaskForm from './taskForm';
import { getTicketById, getTicketList } from '../../redux/selector';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import addNote from '../../../src/assets/img/crm_home/header/addNote.png';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

const ViewTasks = ({}) => {
  const [activeTab, setActiveTab] = useState('overview');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const ticketID = searchParams.get('id');

  const ticketList = useSelector(getTicketList);

  // const ticketLocalData = useSelector((state) => {
  //   const ticketId = location.state?.id || ticketID; // Use the pre-fetched `leadID`
  //   return getTicketById(state, ticketId);
  // });

  const [ticketLocalData, setTicketLocalData] = useState(location.state || {});
  const ticketStoreData = useSelector((state) => {
    const ticketId = location.state?.id || ticketID; // Use the pre-fetched `leadID`
    return getTicketById(state, ticketId);
  });

  useEffect(() => {
    setTicketLocalData((prev) => ({ ...prev, ...ticketStoreData }));
  }, [ticketStoreData]);

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    }
  };
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  useEffect(() => {
    const ticketId = location.state?.id || ticketID;
    if (location.pathname.includes('viewTicket')) {
      let updatedFormData;
      if (ticketLocalData?.leadId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          ticket: 'Lead',
          ticketId: 'lead',
        };
      } else if (ticketLocalData?.contactId && ticketLocalData?.accountId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          ticket: 'Contact',
          ticketId: 'contact',
          associate: 'Account',
          associateId: 'account',
        };
      } else if (ticketLocalData?.contactId && ticketLocalData?.campaignId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          ticket: 'Contact',
          ticketId: 'contact',
          associate: 'Campaign',
          associateId: 'campaign',
        };
      } else if (ticketLocalData?.contactId && ticketLocalData?.opportunityId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          ticket: 'Contact',
          ticketId: 'contact',
          associate: 'Opportunity',
          associateId: 'opportunity',
        };
      } else if (ticketLocalData?.contactId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          ticket: 'Contact',
          ticketId: 'contact',
        };
      } else if (ticketLocalData?.campaignId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          associate: 'Campaign', // Changed: Set as associate instead of ticket
          associateId: 'campaign',
        };
      } else if (ticketLocalData?.accountId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          associate: 'Account',
          associateId: 'account',
        };
      } else if (ticketLocalData?.opportunityId) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          associate: 'Opportunity',
          associateId: 'opportunity',
        };
      } else if (ticketLocalData?.subject) {
        updatedFormData = {
          ...ticketLocalData,
          type: 'view',
          // associate: "Opportunity",
          // associateId: "opportunity",
        };
      }
      setFormData(updatedFormData);
    }
    if (ticketId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Ticket',
          id: ticketId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Ticket',
          id: ticketId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Ticket',
          id: ticketId,
        })
      );
    }
  }, [location, ticketLocalData?.id]);

  const handleOpenEditForm = (paramsValue) => {
    navigate('/tickets/editTicket', {
      state: formData,
    });
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -50% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="ViewLeadPageOuter">
      <div className="viewHeader ticketView">
        <HeaderProfileBlock localData={ticketLocalData} moduleName={'Ticket'} View={true} />
        <div className="rightActionDskButton">
          <div className="rightAction">
            <button
              className="btn btn-outline-primary"
              onClick={handleOpenEditForm}
              disabled={!formData}
            >
              <img
                src={edit}
                alt="Edit"
                className="me-2"
                style={{ width: '12px', height: '12px' }}
              />
              <span className="btnText">Edit</span>
            </button>
          </div>
          <div className="mob">
            <div className="adnoteMob ms-2">
              <button
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              >
                <img
                  src={addNote}
                  alt="Add a Note"
                  className="me-2"
                  style={{ width: '12px', height: 'auto' }}
                />
                <span className="btnText">Add a Note</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="detailContainer">
        <div className="viewFormContainer">
          <div className="leftBlock">
            <ul>
              {Object.keys(refs).map((key) => (
                <li
                  key={key}
                  onClick={() => scrollToSection(key)}
                  style={{ cursor: 'pointer' }}
                  className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                >
                  <button onClick={() => setActiveTab(key)}>
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                    {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                      <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="rightBlock">
            <div className="addlead_container">
              <Formik initialValues={formData} validationSchema={validationSchema}>
                <Form id="viewForm">
                  <div className="tab-content">
                    <div className="addleadcard1">
                      <div id="overview" className="scrollTo" ref={refs.overview}></div>
                      {formData && (
                        <TaskForm formData={formData} selectedOptions={selectedOptions} />
                      )}
                    </div>
                    <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                    <Attachments localData={ticketLocalData} module={'Ticket'} />

                    <div>
                      <div>
                        <div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>

        <div className="viewFormNotesOuter">
          <div className="ViewFormNotesContainer">
            <Formik initialValues={formData} validationSchema={validationSchema}>
              <Form id="viewForm">
                <div id="notes" className="scrollTo" ref={refs.notes}></div>
                <Notes leadLocalData={ticketLocalData} module={'Ticket'} />
              </Form>
            </Formik>
          </div>
        </div>
      </div>
      <div
        className="offcanvas addNoteMobBlock offcanvas-end"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
            <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
            Notes
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="ViewFormNotesContainer">
            <Formik initialValues={formData} validationSchema={validationSchema}>
              <Form id="viewForm">
                <Notes leadLocalData={ticketLocalData} module={'Ticket'}></Notes>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTasks;
